const redAreas = [
    
 {name: 'Merkaz HaKarmel', lat: 32.80263, lng: 34.983837},
 {name: 'Shambur', lat: 32.791166, lng: 34.982896},
 {name: 'Karmeliya', lat: 32.797406, lng: 34.975196},
 {name: "Neve Sha'anan", lat: 32.791244, lng: 35.014136},
 {name: 'French Carmel', lat: 32.81885, lng: 34.975212},
 {name: 'Vardiya St', lat: 32.7952377, lng: 34.997092},
 {name: 'Denia', lat: 32.768007, lng: 35.005274},
 {name: 'Mt. Karmel West', lat: 32.810294, lng: 34.974523},
 {name: 'Ahuza', lat: 32.785714, lng: 34.986257},
    
  ];

  export default redAreas ;